var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    viewBox: "0 0 28 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#3c4051",
    strokeWidth: 4,
    transform: "translate(.708)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.875,
    cy: 10.875,
    r: 8.875
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.627 17.627l7.357 7.357"
  }))));
}

export default __webpack_public_path__ + "media/news/images/icon_search-8cb1c1c1ab1114eb259d8fadf6c57f31.svg";
export { SvgIconSearch as ReactComponent };